import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail, LOGO_URL } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";

const field = "w-full bg-zinc-950 border border-zinc-700 px-4 py-3 text-sm text-white focus:border-[#FF3B30] outline-none transition-colors";

export default function Login() {
  const { login } = useAuth();
  const { settings } = useSettings();
  const logo = settings.logo_image || LOGO_URL;
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      navigate(user.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-[440px] mx-auto px-6 py-16" data-testid="login-page">
      <img src={logo} alt="MTL" className="h-20 w-20 object-contain mx-auto mb-4" />
      <h1 className="font-display text-4xl uppercase tracking-tight text-center">Log <span className="text-[#FF3B30]">In</span></h1>
      <p className="text-zinc-400 text-sm text-center mt-2 mb-8">Access your orders and account.</p>
      <form onSubmit={submit} className="space-y-4 border border-zinc-800 bg-zinc-900 p-8">
        {error && <div className="bg-[#FF3B30]/10 border border-[#FF3B30] text-[#FF3B30] text-sm px-4 py-3" data-testid="login-error">{error}</div>}
        <input className={field} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        <input className={field} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#FF3B30] text-white font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200 disabled:opacity-50">
          {loading ? "Signing in…" : "Log In"}
        </button>
      </form>
      <p className="text-center text-sm text-zinc-400 mt-6">No account? <Link to="/register" className="text-[#FF3B30] font-bold hover:underline">Create one</Link></p>
    </div>
  );
}
